import { render, staticRenderFns } from "./ReportUserPage.vue?vue&type=template&id=dbf4a452&scoped=true&"
import script from "./ReportUserPage.vue?vue&type=script&lang=js&"
export * from "./ReportUserPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportUserPage.vue?vue&type=style&index=0&id=dbf4a452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf4a452",
  null
  
)

export default component.exports